module.exports = "/img/_/_/_/assets/images/creeper/book/common//10.jpg?6511642a5ad6524462cf7a1c971159fb";